export const baseApi = 'https://cabinet.tviy.energy/admin'
